import { content as contentApi } from '@/api';

async function loadImageFromS3(entityTag, imageElement) {
  let imageResponse;

  try {
    imageResponse = await contentApi.getImage(entityTag);
  } catch (err) {
    console.error('Error while loading the image ', entityTag);
  }

  if (imageResponse && imageResponse.status === 200 && imageResponse.data) {
    // eslint-disable-next-line no-param-reassign
    imageElement.src = imageResponse.data;
    imageElement.classList.remove('client-private-image');
  }
}

async function loadAllImagesOnSCroll() {
  const lazyloadImages = document.querySelectorAll('.client-private-image');
  let lazyloadThrottleTimeout;
  // eslint-disable-next-line no-inner-declarations
  if (lazyloadThrottleTimeout) {
    clearTimeout(lazyloadThrottleTimeout);
  }

  lazyloadThrottleTimeout = setTimeout(() => {
    const scrollTop = window.pageYOffset;
    lazyloadImages.forEach((img) => {
      if (img.offsetTop < window.innerHeight + scrollTop) {
        loadImageFromS3(img.dataset.filenameHash, img);
      }
    });
    if (lazyloadImages.length === 0) {
      document.removeEventListener('scroll', loadAllImagesOnSCroll);
      window.removeEventListener('resize', loadAllImagesOnSCroll);
      window.removeEventListener('orientationChange', loadAllImagesOnSCroll);
    }
  }, 20);
}

async function loadAllImages(doc) {
  const lazyloadImages = doc.querySelectorAll('.client-private-image');
  let img;
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < lazyloadImages.length; i++) {
    img = lazyloadImages[i];
    // eslint-disable-next-line no-await-in-loop
    await loadImageFromS3(img.dataset.filenameHash, img);
  }
}

async function initializeLazyImages() {
  // Initiate the IntersectionObserver for loading lazy images
  const lazyloadImages = document.querySelectorAll('.client-private-image');
  if ('IntersectionObserver' in window) {
    const imageObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (imageObserver) {
            imageObserver.unobserve(entry.target);
          }
          loadImageFromS3(entry.target.dataset.filenameHash, entry.target);
        }
      });
    });

    lazyloadImages.forEach((image) => {
      imageObserver.observe(image);
    });
  } else {
    document.addEventListener('scroll', loadAllImagesOnSCroll);
    window.addEventListener('resize', loadAllImagesOnSCroll);
    window.addEventListener('orientationChange', loadAllImagesOnSCroll);
  }
}

export { loadImageFromS3, loadAllImagesOnSCroll, loadAllImages, initializeLazyImages };
